import React from 'react';

import {Icon, ApproveCircle} from '@optimaxdev/icons';

import {Price} from 'components/price/price';

import {UpsellType} from '../../types/upsellsTypes';
import {UpsellsNotification} from '../upsellsNotification/upsellsNotification';

import s from './upsellsMessages.scss';

export type PropsType = {
    upsells: Array<UpsellType>;
};

/**
 * Display messages for added upsells
 * @param {PropsType} props - added upsells
 * @return {React.ReactElement} component
 */
export const UpsellsMessages: React.FC<PropsType> = React.memo(({upsells}: PropsType) => {
    if (upsells.length === 0) return null;

    return (
        <div className={s.upsellsMessages}>
            {upsells.map((upsell: {title: string; price: number}) => (
                <div className={s.upsellMessage} key={upsell.title}>
                    <UpsellsNotification
                        icon={
                            <Icon
                                className={s.approveIcon}
                                height={13}
                                icon={ApproveCircle}
                                strokeWidth={2}
                                width={13}
                            />
                        }
                        notice="Added"
                    >
                        <p className={s.title}>
                            {upsell.title === 'Digital Block coating'
                                ? 'Blue Light coating'
                                : upsell.title}{' '}
                            for <Price>{upsell.price}</Price> was added to your order
                        </p>
                        <p className={s.desc}>A conformation email will be sent to your inbox</p>
                    </UpsellsNotification>
                </div>
            ))}
        </div>
    );
});

UpsellsMessages.displayName = 'UpsellsMessages';
UpsellsMessages.defaultProps = {
    upsells: [],
};
